import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from '../components/Layout/MainLayout';
import LoginPage from '../pages/Login';
import DiagnosisAssistant from '../pages/DiagnosisAssistant';
import { MedicineBoxOutlined } from '@ant-design/icons';

// 定义路由配置 - 只保留诊断助手(HX)
export const routes = [
  {
    path: '/diagnosis-hx',
    name: '诊断助手(HX)',
    icon: <MedicineBoxOutlined />,
    element: <DiagnosisAssistant moduleId="huanzhegenjinmingxi" />
  }
];

const AppRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* 默认重定向到登录页 */}
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={<MainLayout />}>
          <Route path="/diagnosis-hx" element={<DiagnosisAssistant moduleId="huanzhegenjinmingxi" />} />
          {/* 404 重定向到登录页 */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

// 路由守卫组件
const PrivateRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';
  const token = localStorage.getItem('rbtoken');
  
  if (!isAuthenticated || !token) {
    // 如果未登录或没有token，重定向到登录页
    return <Navigate to="/login" replace />;
  }

  return children;
};

// 修改默认路由为诊断助手(HX)
export const getDefaultRoute = () => '/diagnosis-hx';

export default AppRouter; 